import { A, Button, Div, Span } from 'alkali'
import Icon from 'components/Icon'

import * as DADots from 'images/Boxes.svg'
import * as TagIcon from 'icons/tags.svg'
import * as LeftArrow from 'icons/arrow-left.svg'
import { activeTab } from 'model/StudyCollection'
import { currentAnalysisSelections } from 'model/SearchQuery'

export class ReturnPane extends Div('.return-pane') {
	ready({ evidenceResults }) {
		let categoryParam = location.search.match(/category=([^&]+)/)
		this.append(
			A('.back-link', {
				href: categoryParam ? '/category/' + categoryParam[1] : '/',
				content: [Icon('.left-arrow', { icon: LeftArrow }), 'Back to Dashboard'],
			}),
			Button('#faq-to-report.primary', {
				content: 'View Studies',
				display: activeTab.to(tab => tab == 'report'),
				onclick() {
					activeTab.put('sources')
				}
			}),
			Button('#faq-to-studies.primary', {
				content: 'View Analysis',
				display: activeTab.to(tab => tab != 'report'),
				onclick() {
					activeTab.put('report')
					document.querySelector('.studies-tabs').classList.add('report-view')
					evidenceResults?.showAnalysis()
				}
			}),
			Icon('.dots', {
				icon: DADots,
			}),
			currentAnalysisSelections.to(({ tags }) => {
				console.log("Tags value: ", tags)
				if (tags) {
					return new Div('.tags-container', [
							Div('.tag-header', [Icon('.tag-icon', { icon: TagIcon }), 'Query Tags']),
							Div('.analysis-tags', [
								tags.map(tag => {
									return Div('.analysis-tag', [
										Span('.tag-name.truncate', { content: tag, title: tag }),
									])
								}),
							])
						])
				}
			})
		)
	}
}